import type { ElementType, ReactNode } from 'react';

type IconType = ElementType<{ className?: string; 'aria-hidden'?: boolean }>;

export interface DetailItemProps {
    label: string;
    value: ReactNode;
    icon?: IconType;
}

const DetailItem = ({ label, value, icon: IconComponent }: DetailItemProps) => (
    <div className="space-y-1">
        <p className="flex items-center text-sm text-gray-500">
            {IconComponent && <IconComponent className="mr-2 h-4 w-4 text-gray-400" aria-hidden={true} />}
            {label}
        </p>
        <p className="text-sm font-medium text-gray-900">{value ?? '-'}</p>
    </div>
);

export default DetailItem;
